export default {
    data: () => ({
        // Navigation Configuration
        hasClose: true,
        hasEdit: true,
        hasNew: true,
        hasSave: true,
        hasCancel: true,
        navreload: 0,
        navbuttons: null,
        navConfig: {},
        new_enable: false,
        edit_enable: false,
        save_enable: false,
        cancel_enable: false,
        close_enable: false
    }),
    watch: {
        navbuttons() {
            console.log(`Buttons Changed`);
            console.log("updated button state", this.navbuttons);
            this.processButtonClick(this.navbuttons.click);
        },
        save_enable(){
            this.updateNavigation()
        }
    },
    methods: {
        processButtonClick(button) {
            console.log(`Button = ${button}`);
            if (button === "close") this.closeWorkflow();
            else if (button === "cancel") this.cancelWorkflow()
            else if (button === "save") this.save();
            else if (button === "new") this.newForm();
            else if (button === "edit") this.editForm();
        },
        enableAllNavButtons() {
            this.new_enable = true
            this.edit_enable = true
            this.save_enable = true
            this.cancel_enable = true
            this.close_enable = true
        },
        updateNavigation() {
            // Create the basic navigation scheme
            let nav = {}

            let hasHelp = this.checkHelp()

            nav.close = this.hasClose
            nav.save = this.hasSave
            nav.new = this.hasNew
            nav.edit = this.hasEdit
            nav.cancel = this.hasCancel

            // Enable the buttons
            this.help_enable = hasHelp

            // Determine if a help buttons is available
            if (hasHelp) nav["help"] = true;

            // Figure out the disable status of buttons
            nav["new_disable"] = !this.new_enable;
            nav["edit_disable"] = !this.edit_enable;
            nav["save_disable"] = !this.save_enable;
            nav["cancel_disable"] = !this.cancel_enable;
            nav["close_disable"] = !this.close_enable;

            // Set the title of the nav bar
            if (this.args.hasOwnProperty("title")) nav["title"] = this.args.title

            console.log(`Nav Value = `, nav)

            this.navConfig = nav;
            this.navreload++
        },
        cancelWorkflow() {
            console.log(`Clicked on the cancel button`);
            // Figure out if this needs to return to the main window or close the panel
            if ((this.args !== undefined) && (this.args.hasOwnProperty("popup"))) this.$emit("update:finished", true)
            else {
                this.hasClose = true
                this.hasCancel = false
                this.hasEdit = true
                this.hasNew = true
                this.updateNavigation()
                this.welcomeForm()
                this.clearEditForm()
            }
        },
        closeWorkflow() {
            if (!this.args.hasOwnProperty("popup")) this.$router.go(-1);
            else this.$emit("update:finished", true);
        }
    }

}